import { ref } from 'vue';

export const activeRequests = ref([]);

export const addRequest = controller => {
  activeRequests.value.push(controller);
};

export const cancelAllRequests = () => {
  activeRequests.value.forEach(controller => controller.abort());
  activeRequests.value = [];
};
